import { Button } from '@portals/core/src/components/Button/Button';
import { trackButton } from '@portals/tracking/src/content/trackButton';
import { TrackingContext } from '@portals/tracking/src/context/tracking';
import React, { ComponentProps, useCallback, useContext } from 'react';

import { ContentButton as ContentButtonModel } from '../../../models';
import { ContentButton as ContentButtonUntracked } from './ContentButton.untracked';

interface Props {
  node: ContentButtonModel;
  children?: React.ReactNode;
  sx?: ComponentProps<typeof Button>['sx'];
}

export const ContentButton: React.FC<Props> = ({ node }: Props) => {
  const trackingContext = useContext(TrackingContext);
  const handleTracking = useCallback(
    (payload) => {
      trackButton({
        id: node.id,
        title: node.link[0]?.text,
        ...payload,
      });
    },
    [node.id, node.link]
  );

  if (trackingContext?.trackLink) {
    return (
      <ContentButtonUntracked node={node}>
        {(node.link && node.link[0]?.text) || `${node.variant} Button`}
      </ContentButtonUntracked>
    );
  }

  return (
    <TrackingContext.Provider value={{ trackLink: handleTracking }}>
      <ContentButtonUntracked node={node}>
        {(node.link && node.link[0]?.text) || `${node.variant} Button`}
      </ContentButtonUntracked>
    </TrackingContext.Provider>
  );
};
